package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors
import com.sweetlime.dungeonamigo.presentation.ui.theme.pixelFont
import com.sweetlime.dungeonamigo.presentation.ui.theme.silkFont

/** Section heading with a pixel accent-square bullet and optional right micro-label. */
@Composable
fun SectionTitle(title: String, rightLabel: String? = null, modifier: Modifier = Modifier) {
    val pf = pixelFont()
    val sf = silkFont()

    Row(
        modifier = modifier.padding(bottom = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // 7dp accent square with a 2px hard Vault shadow (pixel bullet)
        Canvas(Modifier.size(9.dp)) {
            val sq = 7.dp.toPx()
            drawRect(BrandColors.Vault, topLeft = Offset(2f, 2f), size = Size(sq, sq))
            drawRect(BrandColors.Ember, size = Size(sq, sq))
        }
        Spacer(Modifier.width(8.dp))
        Text(
            text = title,
            color = BrandColors.Ivory,
            fontFamily = pf,
            fontSize = 17.sp,
            letterSpacing = 0.3.sp,
            modifier = Modifier.weight(1f),
        )
        if (rightLabel != null) {
            Text(
                text = rightLabel,
                color = BrandColors.IvoryDim,
                fontFamily = sf,
                fontSize = 9.sp,
            )
        }
    }
}
